import { RootState } from '@/models/root-state.model';
import { BffCmsHeaderBannersResponse } from '@lucky7ventures/bff-types';
import { createSelector } from 'reselect';

export const selectHeaderBanners = (state: RootState): BffCmsHeaderBannersResponse =>
  state.headerBanners.headerBanners;
export const selectHomepageHeaderBanners = createSelector(selectHeaderBanners, headerBanners =>
  headerBanners.filter(banner => banner.pages?.includes('home')),
);
